<template>
  <div class="switchOrg">
    <setting-header />
    <v-divider class="switchOrg_divider" />
    <section class="switchOrg_content">
      <div v-if="initLoading" class="switchOrg_loading">
        <v-skeleton-loader
          type="list-item-two-line"
          class="switchOrg_skeleton"
        ></v-skeleton-loader>
      </div>
      <article
        v-for="(item, key) in items"
        v-else
        :key="key"
        class="switchOrg_item"
      >
        <app-check2
          no-border
          :value="selectedItem === item.id"
          is-group
          :class="{
            'switchOrg_item--selected': selectedItem === item.id,
          }"
          @input="handleCheck($event, item.id)"
        >
          {{ item.label }}</app-check2
        >
      </article>
    </section>
    <div class="switchOrg_action">
      <v-btn
        class="switchOrg_btn-submit"
        :disabled="submitDisabled"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        組織を切り替える
      </v-btn>
    </div>
    <!-- Message dialog -->
    <clip-dialog-message
      :open="!!dialogMessageText"
      :message="dialogMessageText"
      @onClose="closeDialogMessage"
    />
    <!-- ----------------- -->
  </div>
</template>

<script>
import SettingHeader from '@/views/settings/SettingHeader.vue';
import ClipDialogMessage from '@/components/dialogs/ClipDialogMessage.vue';
import { mapActions, mapState } from 'vuex';
import { authService } from '@/services/auth.service';

export default {
  name: 'SwitchOrg',
  components: {
    SettingHeader,
    ClipDialogMessage,
  },
  data() {
    return {
      submitLoading: false,
      selectedItem: '1',
      currentItem: '1',
      dialogMessageText: '',
      initLoading: true,
    };
  },
  computed: {
    ...mapState({
      userAvatars: (state) => state.settings.userAvatars,
      currentAvatarId: (state) => state.settings.currentAvatarId,
    }),
    submitDisabled() {
      return +this.currentItem === this.selectedItem;
    },
    items() {
      return this.userAvatars.map((avatar) => ({
        id: avatar.id,
        label: avatar.cameraDirectoryName,
      }));
    },
  },
  watch: {
    currentAvatarId: {
      handler: function (val) {
        if (val) {
          this.currentItem = +val;
          this.selectedItem = +val;
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    try {
      this.initLoading = true;
      await this.initializeUserAndCameras();
    } catch (error) {
      console.error(error);
    } finally {
      this.initLoading = false;
    }
  },
  methods: {
    ...mapActions('settings', ['changeCurrentAvatarId', 'fetchInvitedUsers']),
    ...mapActions('common', ['initializeUserAndCameras']),
    async closeDialogMessage() {
      this.dialogMessageText = null;
      await this.routerPush({ name: 'home', params: { switchOrg: true } });
    },
    async handleSubmit() {
      try {
        this.submitLoading = true;
        await authService.scmSignIn(null, this.selectedItem);
        await this.changeCurrentAvatarId({
          id: this.selectedItem,
          updateRecentAvatars: true,
        });
        await this.initializeUserAndCameras();
        this.dialogMessageText = '組織を切り替えました。';
      } catch (error) {
        console.error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    handleCheck(checked, id) {
      this.selectedItem = +id;
    },
  },
};
</script>

<style lang="scss">
.switchOrg {
  overflow: auto;
  height: 100%;

  &_item {
    padding: 15px 0;
    user-select: none;
    &:not(:last-child) {
      border-bottom: solid 1px #eeeeee;
    }
    &--selected {
      .customCheck2_label {
        color: #0075c2;
      }
    }
  }
  &_divider {
    margin-top: 16px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &_loading {
    padding: 15px 0;
  }
  &_skeleton {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &_gap-header {
    height: 26px;
  }
  &_action {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #ccc;
    &-delete {
      padding: 9px 0;
    }
    padding: 15px 0;
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
  }
  &_btn {
    &-submit {
      &.theme--light.v-btn.v-btn--has-bg {
        height: 36px;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #0075c2;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
      }
      &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
        background-color: #f3f3f3 !important;
        box-shadow: none;
        color: #ccc !important;
      }
    }

    &-delete {
      .icon-trash {
        font-size: 16px;
        color: #989898;
      }
    }
  }
}
</style>
